import Validator from "js-object-validation";
import { message } from "../common";

export const discountValidator = (data) => {
  const validations = {
    discount: {
      required: true,
      numeric: true,
    },
  };
  // Error messages
  const messages = {
    discount: {
      required: message.Required.replace(":item", "discount"),
      numeric: message.InvalidNumber,
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
